
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'utilisateurs': {
    width: 18,
    height: 19,
    viewBox: '0 0 18 19',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M2.44413 3.47868C2.44413 1.93201 3.74894 0.627197 5.29562 0.627197C6.84229 0.627197 8.1471 1.93201 8.1471 3.47868C8.1471 5.02536 6.84229 6.33017 5.29562 6.33017C3.74894 6.33017 2.44413 5.02536 2.44413 3.47868ZM9.77652 3.47868C9.77652 1.90336 11.0527 0.627197 12.628 0.627197C14.2033 0.627197 15.4795 1.90336 15.4795 3.47868C15.4795 5.054 14.2033 6.33017 12.628 6.33017C11.0527 6.33017 9.77652 5.054 9.77652 3.47868ZM5.29562 7.95959C1.30481 7.95959 0 11.2184 0 11.2184V12.8478H10.5912V11.2184C10.5912 11.2184 9.28642 7.95959 5.29562 7.95959ZM9.70014 8.69792C10.4321 8.29056 11.4059 7.95959 12.628 7.95959C16.1165 7.95959 17.5477 10.4497 17.908 11.0765C17.9599 11.1668 17.9896 11.2184 18 11.2184V12.8478H11.4823V11.0657L11.4059 10.8875C11.3895 10.871 11.3572 10.8132 11.3071 10.7234C11.105 10.3616 10.613 9.48074 9.70014 8.69792Z"/>'
  }
})
